// extracted by mini-css-extract-plugin
export default {"modalDescription":"styles_modalDescription__+PRHj","description":"styles_description__m8H4p","image":"styles_image__Po1mY"};